export default __webpack_public_path__ + "static/media/106.a20994c2.jpg";